import { render, staticRenderFns } from "./CustomerContactPersonNewPopup.vue?vue&type=template&id=0424e822&"
import script from "./CustomerContactPersonNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerContactPersonNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports